import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		total_results: 0,
		sorted: undefined,
		filters: {
			query: '',
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH INGESTER ENCODING ***************
			case types.FETCH_INGESTER_ENCODING_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_INGESTER_ENCODING_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				return;

			case types.FETCH_INGESTER_ENCODING_ERROR:
				draft.error = action.payload;
				return;

			// *************** FETCH INGESTER ENCODING - VOD DETAILS DATA ***************
			case types.FETCH_INGESTER_ENCODING_VOD_DETAILS_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_INGESTER_ENCODING_VOD_DETAILS_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				return;

			case types.FETCH_INGESTER_ENCODING_VOD_DETAILS_ERROR:
				draft.error = action.payload;
				return;

			// ******************** REFRESH INGESTER ENCODING ********************
			case types.REFRESH_INGESTER_ENCODING:
				draft.data = [];
				return;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_INGESTER_ENCODING_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_INGESTER_ENCODING_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				return;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
